import { render, staticRenderFns } from "./product_designs.vue?vue&type=template&id=15105142&scoped=true"
import script from "./product_designs.vue?vue&type=script&lang=js"
export * from "./product_designs.vue?vue&type=script&lang=js"
import style0 from "./product_designs.vue?vue&type=style&index=0&id=15105142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15105142",
  null
  
)

export default component.exports